import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  FormArray,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  EarningsRepartition,
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<Omit<EarningsRepartition, 'taxAmount'>> = {
      taxShareNumber: [parameters?.taxShareNumber || null, Validators.required],

      amount: [
        parameters?.earningsRepartition?.amount || 0,
        Validators.required,
      ],

      salaryOrRetirement: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.salaryOrRetirement?.percent * 100,
          ) || 0,
        ],
        amount: [
          parameters?.earningsRepartition?.salaryOrRetirement?.amount || 0,
        ],
      }),
      propertyIncome: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.propertyIncome?.percent * 100,
          ) || 0,
        ],
        amount: [parameters?.earningsRepartition?.propertyIncome?.amount || 0],
      }),
      bicIncome: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.bicIncome?.percent * 100,
          ) || 0,
        ],
        amount: [parameters?.earningsRepartition?.bicIncome?.amount || 0],
      }),
      movableIncome: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.movableIncome?.percent * 100,
          ) || 0,
        ],
        amount: [parameters?.earningsRepartition?.movableIncome?.amount || 0],
      }),
      bncIncome: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.bncIncome?.percent * 100,
          ) || 0,
        ],
        amount: [parameters?.earningsRepartition?.bncIncome?.amount || 0],
      }),
      baIncome: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.earningsRepartition?.baIncome?.percent * 100,
          ) || 0,
        ],
        amount: [parameters?.earningsRepartition?.baIncome?.amount || 0],
      }),
      salaryAmount: [parameters?.earningsRepartition?.salaryAmount || 0],
      retirementAmount: [
        parameters?.earningsRepartition?.retirementAmount || 0,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  formGroup(): FormGroup {
    return this.formBuilder.group({
      fundOrigin: ['LIQUIDITY', Validators.required],
      distribution: [100, Validators.required],
    });
  }
  extract() {
    const formValue = _.cloneDeep({ ...this.form.value });
    const amount = formValue.amount;
    for (const key in formValue) {
      if (Object.prototype.hasOwnProperty.call(formValue, key)) {
        const element = formValue[key] as any;

        if (typeof element === 'object' && element !== null) {
          element.percent = element.percent / 100;
          element.amount = amount * element.percent;
        }
      }
    }
    return {
      earningsRepartition: { ...formValue },
      taxShareNumber: formValue.taxShareNumber,
    };
  }
  floored(value) {
    if (value) return Math.round(value * 100) / 100;
  }
}
